import { useState, useEffect } from "react";
import { Box, TextField, Button } from "@mui/material";
import { UseDeliveryManage } from "./UseDeliveryManage";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DeliveriesGrid from "./DeliveriesGrid";

export default function DeliveryManage() {
  const { toSolar } = require("jdate-convert");
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const [valueDate, setValueDate] = useState();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getParts } = UseDeliveryManage();
  const { myPc, refresh } = UseMyPC();
  const [parts, setParts] = useState();
  const [filters, setFilters] = useState({
    deliveryDate: new Date().toJSON().slice(0, 10),
    deliveryPart: undefined,
  });

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getParts(
      myPc,
      (parts) => {
        setFilters({
          ...filters,
          deliveryPart: parts.parts[0].id,
        });
        setParts(parts);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    refresh();
  }, []);

  useEffect(() => {
    if (valueDate) {
      let newValueStart = valueDate?.toDate?.().toLocaleDateString("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      setFilters({ ...filters, deliveryDate: newValueStart });
    }
  }, [valueDate]);

  return (
    <Detail
      breadChilds={{
        title: "لجستیک",
        childs: [{ name: msActiveMenu.pageTitle, url: "/deliverymanage" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <DatePicker
            // highlightToday={false}
            onOpenPickNewDate={false}
            weekDays={weekDays}
            calendar={persian}
            locale={persian_fa}
            format="YYYY-MM-DD"
            value={filters.deliveryDate ? toSolar(filters.deliveryDate) : ""}
            onChange={setValueDate}
            render={
              <TextField
                sx={{ input: { textAlign: "center" } }}
                variant="outlined"
                size="small"
                fullWidth
                label="تاریخ"
              />
            }
          />
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {parts &&
              parts.parts.map((part) => {
                return (
                  <Button
                    sx={{ width: "100px" }}
                    startIcon={filters.deliveryPart == part.id && <CheckIcon />}
                    variant={
                      filters.deliveryPart == part.id ? "contained" : "outlined"
                    }
                    color={
                      filters.deliveryPart == part.id ? "secondary" : "primary"
                    }
                    key={part.id}
                    onClick={() => {
                      setFilters({ ...filters, deliveryPart: part.id });
                    }}
                  >
                    {part.title}
                  </Button>
                );
              })}
          </Box>
        </Box>
        <Box sx={{ mt: 2, flexGrow: 1, height: "100%" }}>
          <DeliveriesGrid filters={filters} />
        </Box>
      </Box>
    </Detail>
  );
}
